import { render, staticRenderFns } from "./ToothItem.vue?vue&type=template&id=3afc21e0&scoped=true"
import script from "./ToothItem.vue?vue&type=script&lang=js"
export * from "./ToothItem.vue?vue&type=script&lang=js"
import style0 from "./ToothItem.vue?vue&type=style&index=0&id=3afc21e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3afc21e0",
  null
  
)

export default component.exports